import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import { useDataFetchIndicator } from '@/hooks';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ApiResponse | undefined,
  (params: vp.ChartOfAccountRequest) => void,
  (params: vp.ChartOfAccountRequest) => Promise<vp.ApiResponse>,
  () => void,
];

function usePostSetRailzChartOfAccount({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.ChartOfAccountRequest>();
  const [response, setResponse] = useState<vp.ApiResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.ChartOfAccountRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.postSetRailzChartOfAccount(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.ChartOfAccountRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    (requestParams: vp.ChartOfAccountRequest) => {
      const res = api.postSetRailzChartOfAccount(requestParams, source);
      return res;
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostSetRailzChartOfAccount);
